export default "__VITE_ASSET__DlatTYWW__"